<template>
  <section
    id="home"
    ref="hero"
    class="section cv-fullwidth dark-gradient cover-title active"
  >
    <div class="row justify-content-md-center align-items-center cv-fullheight">
      <div class="col-auto col-sm-8 col-lg-auto">
        <h1
          class="wow fadeInUpShort"
          v-html="title"
        ></h1>
        <h3
          class="wow fadeInUpShort delay-04s"
          v-html="subtitle"
        ></h3>
      </div>
    </div>
    <a
      class="btn goto next-section"
      title="Explore"
      @click="scroll"
    ></a>
  </section>
</template>

<script>
import { currentSection } from './../../mixins/changeSection';

export default {
  name: 'hero-banner',
  mixins: [currentSection],
  props: ['title', 'subtitle', 'nextSection'],
  methods: {
    scroll() {
      const hashed = '#' + this.nextSection;
      this.$scrollTo(hashed);
      window.location.hash = hashed;
    }
  }
};
</script>
